import { ChangeDetectionStrategy, Component, Resource, signal } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-enterprise';
import { ResourceContainerComponent } from '@softapps/core';

@Component({
  selector: 'soft-grid-loading',
  imports: [
    ResourceContainerComponent
  ],
  template: `
    @if (resource(); as res) {
      <soft-resource-container [resource]="res"></soft-resource-container>
    }
  `,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridLoadingOverlay implements ILoadingOverlayAngularComp {
    resource = signal<Resource<any> | undefined>(undefined);

    agInit(params: ILoadingOverlayParams<any, any> & {dataSource?: Resource<any>}): void {
      this.resource.set(params.dataSource);
    }
    refresh?(params: ILoadingOverlayParams<any, any> & {dataSource?: Resource<any>}): void {
      this.resource.set(params.dataSource);
    }
}
